module.exports = "\r\n<app-plan-order-frame [rootActivatedRoute]=\"activatedRoute\"\r\n></app-plan-order-frame>\r\n"